// import ThemePresenter from './presenters/ThemePresenter';
import 'globalStyles/theme.scss';

import { EventEmitter } from '@firenet-designs/shopify-common';

EventEmitter.polyfill();

const FND = (window.FND = window.FND || {});
FND.BUILDS = FND.BUILDS || {};
FND.BUILDS.Theme = FND.BUILDS.Theme || {};
// FND.BUILDS.Theme.init = ThemePresenter;